import React from "react";
import { Button } from "../../ui/button";

/** Bulk actions for the selected requests. */
const SelectionBar = ({
  count,
  onClear,
  onAssignDate,
  onChangeLaunchDate,
  onAssignSprint,
  onDelete,
}) => (
  <div className="flex flex-wrap items-center gap-2 rounded-lg border border-[#e3e0fa] bg-[#f6f5fe] px-3 py-2">
    <span className="text-sm font-medium text-gray-800">{count} selected</span>
    <button
      type="button"
      onClick={onClear}
      className="text-xs text-gray-500 hover:text-gray-800 hover:underline underline-offset-2"
    >
      Clear
    </button>
    <div className="ml-auto flex flex-wrap gap-2">
      <Button size="sm" onClick={onAssignDate}>
        Assign delivery date
      </Button>
      {onChangeLaunchDate && (
        <Button size="sm" variant="outline" onClick={onChangeLaunchDate}>
          Change launch date
        </Button>
      )}
      <Button size="sm" variant="outline" onClick={onAssignSprint}>
        Assign to sprint
      </Button>
      <Button
        size="sm"
        variant="outline"
        onClick={onDelete}
        className="text-red-600 border-red-200 hover:bg-red-50 hover:text-red-700"
      >
        Delete selected
      </Button>
    </div>
  </div>
);

export default SelectionBar;
